import { Component, ViewChild } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexLegend,
  ApexTooltip,
  ApexNonAxisChartSeries,
  ApexResponsive,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { MaterialModule } from 'src/app/material.module';

export interface yearlySalesChart {
  series: ApexNonAxisChartSeries | any;
  chart: ApexChart | any;
  responsive: ApexResponsive[] | any;
  labels: any;
  tooltip: ApexTooltip | any;
  legend: ApexLegend | any;
  colors: string[] | any;
  stroke: any;
  dataLabels: ApexDataLabels | any;
  plotOptions: ApexPlotOptions | any;
}

@Component({
  selector: 'app-yearly-distribution-performance',
  standalone: true,
  imports: [NgApexchartsModule, MaterialModule, TablerIconsModule],
  templateUrl: './yearly-distribution-performance.component.html',
})
export class YearlyDistributionPerformanceComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  public p1Chart!: Partial<performanceChart> | any;

  public yearlySalesChart!: Partial<yearlySalesChart> | any;
  constructor() {
    this.p1Chart = {
      series: [
        {
          name: 'Products Performance',
          data: [35, 40, 50, 20, 60],
        },
      ],

      grid: {
        show: false,
      },
      colors: ['#26c6da'],
      chart: {
        toolbar: {
          show: false,
        },
        foreColor: '#adb0bb',
        fontFamily: `inherit`,
        type: 'line',
        height: 30,
        sparkline: {
          enabled: true,
        },
      },
      markers: {
        size: 0,
      },
      legend: {
        show: false,
      },
      stroke: {
        show: true,
        width: 2,
        curve: 'smooth',
      },
      tooltip: {
        theme: 'dark',
      },
    };
  }
}
export interface performanceChart {
  series: ApexNonAxisChartSeries | any;
  chart: ApexChart | any;
  responsive: ApexResponsive[] | any;
  labels: any;
  tooltip: ApexTooltip | any;
  legend: ApexLegend | any;
  colors: string[] | any;
  stroke: any;
  dataLabels: ApexDataLabels | any;
  plotOptions: ApexPlotOptions | any;
}
